import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { howItWorks as orgConfig } from 'org/configs/modules.config';

/** @type {object} */
const defaultConfig = {
  defaults: {
    hiwItems: [],
    videoId: '',
    videoPlayer: '',
    getVideoLinkText: () => 'Watch how it works',
    getVideoAutoplay: () => (false),
    getSectionTitleText: () => ('How it works'),
    checkShouldShowVideoButton: () => (false),
    checkShouldShowVideoLink: () => (false),
    checkShouldUseCarousel: (userIsIdentified, isPersonalizedMhp) => {
      if (isPersonalizedMhp) return false;
      return userIsIdentified;
    },
    checkShouldUseInvertedView: (userIsIdentified) => (userIsIdentified),
    shouldShowVideoPlayButton: false,
    carousel: {
      align: 'center',
      loop: true,
      isClipped: true,
      breakpoints: {
        m: { isClipped: false },
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
